








import Vue from 'vue'
import Preview from './preview/Preview.vue'
import Sidebar from './sidebar/Sidebar.vue'
import SectionDetails from './sidebar/sidebarDetails/SectionDetails.vue'
import DraftStateController from '@/calendesk/controllers/DraftStateController'
export default Vue.extend({
  name: 'Builder',
  components: { Preview, Sidebar, SectionDetails },
  mounted () {
    window.addEventListener('beforeunload', this.warnAboutPendingSaves)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.warnAboutPendingSaves)
  },
  methods: {
    // A save can sit in its debounce window for up to a second after the last
    // edit; closing the tab then would lose it despite the autosave promise.
    warnAboutPendingSaves (event: BeforeUnloadEvent) {
      const controller = DraftStateController.getInstance()

      if (controller.hasPendingSaves()) {
        controller.flushPendingSaves()
        event.preventDefault()
        event.returnValue = ''
      }
    }
  }
})
